@if (formGroup) {
  <div [formGroup]="formGroup">
    <time-series-dynamic-selection
      formGroupName="identifier"
    ></time-series-dynamic-selection>
  </div>
}
